const LIB_DEBUG_LOGGER = 'production' !== process.env.NODE_ENV ? console.warn : null;

const constants = Object.freeze({
  LIB_DEBUG_LOGGER: LIB_DEBUG_LOGGER
});

export default constants;
